import { axiosMarketplace } from "../../services/axios";

const getPublicApplications = async ({queryKey}) => {
  const res = await axiosMarketplace.get("/application/published", {params: queryKey?.[1]});
  return res.data;
};

export default getPublicApplications;
